import { render, staticRenderFns } from "./dialogoApoyo.vue?vue&type=template&id=c273aa94&scoped=true"
import script from "./dialogoApoyo.vue?vue&type=script&lang=js"
export * from "./dialogoApoyo.vue?vue&type=script&lang=js"
import style0 from "./dialogoApoyo.vue?vue&type=style&index=0&id=c273aa94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c273aa94",
  null
  
)

export default component.exports